import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Site Survey & Audit",
    desc: "We walk your site, map your existing infrastructure, and identify gaps and bottlenecks.",
  },
  {
    n: "02",
    title: "Design & Proposal",
    desc: "A tailored design — diagrams, BOM, and a fixed-scope proposal with clear SLAs.",
  },
  {
    n: "03",
    title: "Installation & Integration",
    desc: "Certified engineers install, dress, label and integrate every component cleanly.",
  },
  {
    n: "04",
    title: "Testing & Certification",
    desc: "OTDR, Fluke and performance testing — every link is certified before handover.",
  },
  {
    n: "05",
    title: "Monitoring & Support",
    desc: "Health checkups, heatmap reviews and on-call support keep you running smoothly.",
  },
];

const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid-faint" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF6B00] mb-4">
              ◆ Our Process
            </div>
            <h2 data-testid="process-title" className="font-display text-4xl sm:text-5xl font-bold leading-[1.05] tracking-tighter">
              From survey to certified <br />
              <span className="text-[#A0B2C6]">— a deliberate, measured workflow.</span>
            </h2>
          </div>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-5 gap-px bg-white/8 border border-white/8" data-testid="process-grid">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="bg-[#0B1320] p-7 hover:bg-[#111C2E] transition-colors group relative"
              data-testid={`process-step-${s.n}`}
            >
              <div className="flex items-baseline justify-between">
                <span className="font-mono text-xs text-[#FF6B00] tracking-[0.25em]">{s.n}</span>
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A0B2C6]">step</span>
              </div>
              <h4 className="mt-5 font-display text-xl font-semibold tracking-tight">{s.title}</h4>
              <p className="mt-2 text-sm text-[#A0B2C6] leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
